import React, { Suspense, useEffect, useState } from "react";
import StudentLoginBg from "../assets/student-login-bg.png";
import TeacherQueryImg from "../assets/teacher-qrcode-help.png";
import './styles.scss';
const QRcodeInput = React.lazy(() => import("./QRcodeInput").then(module => ({ default: module.QRcodeInput })));
import { useAuthSigninState } from "../state";
import { setupHideElementsObserver } from "../../teacherDashboard/teacher/config/common";

export const StudentQRCodeLogin = () => {

  const { showQRPopup, getFromPage } = useAuthSigninState()
  const [hasCameraAccess, setHasCameraAccess] = useState();

  useEffect(() => {
    if(window.location.hash.includes('student-qrcode')){
      trackEventsForGuests("Viewed QR Code Input Screen", { "mp_login_user_type": "student", "From page": getFromPage() || "Direct URL entered" }, { send_mixpanel: true })
    }
    trackAnalyticsEvent('Viewed QR Code Screen', {'Intent for': 'login', 'Screen type': 'page', 'From Page': 'signin'}, true);

    // Set up observer to hide consent and overlay elements
    const cleanupObserver = setupHideElementsObserver();

    return () => {
      // Clean up observer and restore elements
      cleanupObserver();
    }
  }, [])

  const sendInteractedEvent = (clickedOn = '') => {
    trackEventsForGuests("Interacted QR Code Input Screen", { "mp_login_user_type": "student", "Clicked on": clickedOn }, { send_mixpanel: true })
    trackEventsForGuests(hasCameraAccess ? 'Interacted QR code Input Screen Camera Access' : "Interacted QR code Input Screen No Camera Access", { "mp_login_user_type": "student", "Clicked on": clickedOn }, { send_mixpanel: true })
  }

  return (
    <div className="student-login">
      {!showQRPopup ? <button className="login-back" onClick={() => {sendInteractedEvent("Back Button"); window.location.hash = "#student"}} aria-label="Go back"><i className="iconcust-iconBackBtn"></i></button> : null}
      <div className="student-login-bg">
        <img src={StudentLoginBg} alt=""/>
      </div>
      <div className={`student-login-body qr-code`}>
        <h4>Scan the QR code</h4>
        <Suspense fallback={'Loading...'}><QRcodeInput setHasCameraAccess={setHasCameraAccess}/></Suspense>
        <p>
          Login via <a href="#student-klasscode?fromPage=QR code scan input screen" onClick={() => sendInteractedEvent("Login via class code")} aria-label="Login via class code">Class code</a>
        </p>
        <img
          src={TeacherQueryImg}
          alt="Don’t have your QR code? Ask your teacher for help."
        />
      </div>
    </div>
  );
};
